export default {
	'log-manage': {
		id: 'log-manage',
		label: '操作日志',
		code: '0002_0001'
	}
}
